import { useWalletLogContext } from "../../../../../hooks/wallet-log-context";
import {
  checkMileageLogString,
  checkMileageLogType,
  subTitleForMileage,
} from "../../../utils/log-type";
import {
  WalletLogsListRow,
  WalletLogListDate,
  WalletLogsListItemWrapper,
  WalletLogsListItem,
  WalletLogsListItemInfo,
  WalletLogsRowBorder,
} from "../style";

const WalletLogsMileageList = () => {
  const { mileageLogs } = useWalletLogContext();

  const formatDate = (value: string) => {
    const [_, month, day] = value.split("-");
    return `${month}.${day}`;
  };

  return (
    <>
      {mileageLogs.map((item, index) => (
        <>
          <WalletLogsListRow key={index}>
            <WalletLogListDate>{formatDate(item.date)}</WalletLogListDate>
            <WalletLogsListItemWrapper>
              {item.list.map((log, i) => (
                <WalletLogsListItem key={i}>
                  <WalletLogsListItemInfo>
                    <div className="info">
                      {log.pubName} {checkMileageLogString(log.type)}
                    </div>
                    <div className="date">
                      {subTitleForMileage(log.type, log)}
                    </div>
                  </WalletLogsListItemInfo>
                  <div className="point">
                    {checkMileageLogType(log.type) ? "+" : "-"}
                    {log.point?.toLocaleString()} M
                  </div>
                </WalletLogsListItem>
              ))}
            </WalletLogsListItemWrapper>
          </WalletLogsListRow>
          <WalletLogsRowBorder />
        </>
      ))}
    </>
  );
};

export default WalletLogsMileageList;
